import React, { useEffect, useState } from 'react';
import './ContactForm.css';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = 'Name is required.';
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required.';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Email is invalid.';
    }
    if (!formData.message.trim()) newErrors.message = 'Message cannot be empty.';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.has('success')) {
      alert('Thank you for your message! I will get back to you soon.');
    }
  }, []);

  return (
    <section className="contact-section">
      <div className="contact-form-container">
        <div className="contact-form-header">
          <h2>Get in <span className="highlight">Touch</span></h2>
          <p>Have a project in mind or want to discuss opportunities? Drop us a message!</p>
        </div>

        <form
          action="https://formsubmit.co/support@skriptdev.com"
          method="POST"
          className="contact-form"
          onSubmit={(e) => {
            if (!validate()) e.preventDefault();
          }}
        >
          {/* Honeypot */}
          <input type="text" name="_honey" style={{ display: 'none' }} />
          {/* Disable CAPTCHA */}
          <input type="hidden" name="_captcha" value="false" />
          {/* Redirect after success */}
          <input type="hidden" name="_next" value="http://localhost:3000/contact?success=true" />

          <div className="form-group floating">
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <label>Your Name</label>
            <div className="underline"></div>
            {errors.name && <small className="error">{errors.name}</small>}
          </div>

          <div className="form-group floating">
             <input
    type="email"
    name="email"
    value={formData.email}
    onChange={handleChange}
    required
    className={formData.email ? 'filled' : ''}
  />
  <label className={formData.email ? 'filled' : ''}>Email Address</label>
  <div className="underline"></div>
  {errors.email && <small className="error">{errors.email}</small>}
          </div>

          <div className="form-group floating">
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
            />
            <label>Your Message</label>
            <div className="underline"></div>
            {errors.message && <small className="error">{errors.message}</small>}
          </div>

          <button type="submit" className="submit-btn">
            Send Message
          </button>
        </form>

        <div className="contact-decoration">
          <div className="decoration-circle orange"></div>
          <div className="decoration-circle pink"></div>
          <div className="decoration-dots"></div>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
